(() => {

  function initTrustCarousels() {

    const tracks = document.querySelectorAll(
      '.section-content-wrapper.layout-panel-flex'
    );

    tracks.forEach(track => {

      const marker = getComputedStyle(track)
        .getPropertyValue('--sd-trust-carousel')
        .trim();

      if (marker !== '1') return;

      if (track.dataset.sdTrustReady === 'true') return;

      const items = Array.from(
        track.querySelectorAll(':scope > .group-block')
      );

      if (items.length < 2) return;

      const section =
        track.closest('.shopify-section') ||
        track.parentElement;

      if (!section) return;

      const existingDots =
        section.querySelector('.sd-trust-dots');

      if (existingDots) existingDots.remove();

      const dots = document.createElement('div');
      dots.className = 'sd-trust-dots';

      items.forEach((item, index) => {

        const dot = document.createElement('button');

        dot.type = 'button';

        dot.className =
          'sd-trust-dot' +
          (index === 0 ? ' is-active' : '');

        dot.setAttribute(
          'aria-label',
          `View item ${index + 1}`
        );

        dot.addEventListener('click', () => {

          track.scrollTo({
            left: item.offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });

        });

        dots.appendChild(dot);

      });

      track.insertAdjacentElement('afterend', dots);


      function updateDots() {

        let closest = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {

          const distance = Math.abs(
            item.offsetLeft -
            track.scrollLeft -
            track.offsetLeft
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closest = index;
          }

        });

        dots
          .querySelectorAll('.sd-trust-dot')
          .forEach((dot, index) => {

            dot.classList.toggle(
              'is-active',
              index === closest
            );

          });

      }


      track.addEventListener(
        'scroll',
        updateDots,
        { passive: true }
      );

      track.dataset.sdTrustReady = 'true';

      updateDots();

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initTrustCarousels
    );

  } else {

    initTrustCarousels();

  }


  document.addEventListener(
    'shopify:section:load',
    () => {
      setTimeout(initTrustCarousels, 100);
    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    () => {
      setTimeout(initTrustCarousels, 100);
    }
  );

})();